import React from 'react';
import PropTypes from 'prop-types';

import { Headline, Subheadline } from 'common/components/Typography';

const baseClassName = 'WorkspaceTopbarTitle';

const WorkspaceTopbarTitle = ({ title, subtitle, headerStyles }) => (
    <header style={headerStyles} className={baseClassName}>
        <div className={`${baseClassName}__headline`}>
            {subtitle && (
                <Subheadline className={`${baseClassName}__headline__subtitle`} size="small">
                    {subtitle}
                </Subheadline>
            )}
            <Headline
                className={`${baseClassName}__headline__title`}
                size={!subtitle ? 'medium' : 'small'}
                data-qa={title}
            >
                {title}
            </Headline>
        </div>
    </header>
);

WorkspaceTopbarTitle.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    headerStyles: PropTypes.object,
};

WorkspaceTopbarTitle.defaultProps = {
    subtitle: null,
    headerStyles: {},
};

export default WorkspaceTopbarTitle;
